export default __webpack_public_path__ + "static/media/turkey.76b7b943.png";